import React, { useState } from "react";
import { useMyContext } from "../../my-context/MyContext";
import i18n from "../../../utils/localization/i18n";
import { languageDetails } from "../../../utils/common";
import { useTranslation } from "react-i18next";
function LoginFooter() {
  const { setLanguage, language, isExternalUser } = useMyContext();
  const [languages, setLanguages] = useState<any[]>(languageDetails);

  const [selectedLanguage, setSelectedLanguage] = useState("");

  const handleLanguageChange = (event: any) => {
    const selectedLanguage = event.target.value;
    const selectedLanguageDetails = languages.find(
      (lang) => lang.code === selectedLanguage
    );
    setSelectedLanguage(selectedLanguage);
    setLanguage(selectedLanguage);
    sessionStorage.setItem(
      "selectedLanguageDetails",
      JSON.stringify(selectedLanguageDetails)
    );
    i18n.changeLanguage(selectedLanguage);
  };
  const { t } = useTranslation();
  return (
    <div className="w-full h-auto">
      <div className="w-full h-auto flex justify-center items-center">
        <div className="w-auto h-auto">
          <p className="text-[1.6rem] font-inter font-normal text-io-gray-66">
            &copy; {t("web.loginfooter.label.copyright")}
          </p>
        </div>
      </div>
    </div>
  );
}
export default LoginFooter;
